const initialState = { 
  loading: false,
  success: null,
  error: null
}

function hideReviewProductReducer(state = initialState, action) {
  switch (action.type) {
    case 'HIDE_REVIEW_PRODUCT_BEGIN':
      return {
        ...state,
        loading: true,
        success: null,
        error: null
      }

    case 'HIDE_REVIEW_PRODUCT_SUCCESS':
      return {
        ...state,
        loading: false,
        success: action.success
      }

    case 'HIDE_REVIEW_PRODUCT_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default hideReviewProductReducer
